import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { from, Observable } from 'rxjs';
import { EntityDocument } from '../entity-document-tree/entity-document.model';
import { EnvironmentService } from '../environment.service';
import { AuthService } from '../services/auth.service';
import { map, switchMap } from 'rxjs/operators';
import { DocumentViewerConfiguration } from '../models/document-viewer-configuration.model';

@Injectable({
  providedIn: 'root'
})
export class DocumentService {
  private apiPrefix = 'api/documentaccessview';

  constructor(private http: HttpClient, protected envService: EnvironmentService, private authService: AuthService) { }

  getDocuments(keyword: string): Observable<EntityDocument> {
    return from(this.authService.getAccessToken()).pipe(
      switchMap(token => {
        const headers = new HttpHeaders({
          'Authorization': `Bearer ${token}`
        });

        return this.http.get<EntityDocument>(
          `${this.envService.getApiUrl()}/${this.apiPrefix}/${keyword}`,
          { headers }
        );
      })
    );
  }

  getDocumentViewerConfiguration(): Observable<DocumentViewerConfiguration> {
    return this.http.get<DocumentViewerConfiguration>(`${this.envService.getApiUrl()}/${this.apiPrefix}/documentViewerConfiguration`).pipe(
      map(result => {
        return result;
      })
    );
  }
}
